import React from 'react';
import YoutubeSearchApi from '../../components/admin/YoutubeSearchApi';

const YoutubeSearchApiPage = () => {
  return <YoutubeSearchApi />;
};

export default YoutubeSearchApiPage;
